import { render, staticRenderFns } from "./uploadAttachment.vue?vue&type=template&id=32c616cc&scoped=true"
import script from "./uploadAttachment.vue?vue&type=script&lang=js"
export * from "./uploadAttachment.vue?vue&type=script&lang=js"
import style0 from "./uploadAttachment.vue?vue&type=style&index=0&id=32c616cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c616cc",
  null
  
)

export default component.exports